module.exports = __webpack_public_path__ + "f88d977ab360716e0a488cfc11ad0632.MP3";